import React, { SyntheticEvent, useRef } from "react";
import { Button } from "react-bootstrap";
import { FileStatus } from "../../type/FileStatusType";
import { Trans } from "react-i18next";

interface UploadCSVSubmitType {
  fileDetails: File | null;
  userId: string;
  setFileStatus: (filename: FileStatus) => void;
  handleFileSubmit: () => void;
  handelFileUpload: (fileInfo: File[]) => void;
}

const UploadCSVSubmit = ({
  fileDetails,
  handleFileSubmit,
  userId,
  setFileStatus,
  handelFileUpload,
}: UploadCSVSubmitType) => {
  const fileInput = useRef<HTMLInputElement>(null);
  const handleFileInputChange = (event: SyntheticEvent<EventTarget>) => {
    event.preventDefault();
    event.stopPropagation();
    const fileUploaded = (event.target as HTMLFormElement).files;
    handelFileUpload([...fileUploaded]);
  };
  return (
    <div>
      <input
        type="file"
        name="file"
        hidden
        onChange={handleFileInputChange}
        accept=".csv,text/csv"
        ref={fileInput}
      />
      <div>
        <img src="/icons/ProgressFileIcon.svg" alt="ProgressFileIcon" />
        <span className="addUserSubmitTitle">
          {userId} {fileDetails?.name}
        </span>
      </div>
      <div>
        <Button
          className="addUserSubmitPrimaryButton"
          onClick={() => {
            handleFileSubmit();
          }}
        >
          <Trans i18nKey={"submit"} />
        </Button>
        <Button
          variant="outline"
          className="uploadButton"
          onClick={() => {
            fileInput?.current?.click();
          }}
        >
          <Trans i18nKey={"select_another_file"} />
        </Button>
      </div>
    </div>
  );
};

export default UploadCSVSubmit;
